import React, { useState } from "react"
import { VStack, Input, Text, Button, ModalFooter, ModalBody, ModalHeader, ModalCloseButton } from "@chakra-ui/react"

export default function SetStripeBalances({ onSubmit, onClose }) {
  const [stripeValues, setStripeValues] = useState({ stripeMinimum: "", stripeTarget: "" })
  const [errors, setErrors] = useState({ stripeMinimum: false, stripeTarget: false, targetLessThanMinimum: false })

  const handleChange = (e) => {
    const { name, value } = e.target
    setStripeValues((prevState) => ({ ...prevState, [name]: value }))
  }

  const handleSubmit = () => {
    const newErrors = {
      stripeMinimum: stripeValues.stripeMinimum === "",
      stripeTarget: stripeValues.stripeTarget === "",
      targetLessThanMinimum: parseInt(stripeValues.stripeMinimum) >= parseInt(stripeValues.stripeTarget)
    }

    setErrors(newErrors)

    if (!newErrors.stripeMinimum && !newErrors.stripeTarget && !newErrors.targetLessThanMinimum) {
      onSubmit({
        stripeMinimum: parseInt(stripeValues.stripeMinimum),
        stripeTarget: parseInt(stripeValues.stripeTarget)
      })
    }
  }

  const resetStripeValues = () => {
    setStripeValues({ stripeMinimum: "", stripeTarget: "" })
    setErrors({ stripeMinimum: false, stripeTarget: false, targetLessThanMinimum: false })
  }

  const handleOnClose = () => {
    resetStripeValues()
    onClose()
  }

  return (
    <>
      <ModalHeader>Set Stripe balances</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        {errors.targetLessThanMinimum && (
          <Text color="red.500" mb={4}>
            Stripe account target balance must be larger than the minimum.
          </Text>
        )}
        <VStack spacing={4}>
          <VStack align="start" width="100%">
            <Text as="b">
              Stripe Minimum{" "}
              <Text as="span" color="red">
                *
              </Text>
            </Text>
            <Input
              type="number"
              name="stripeMinimum"
              value={stripeValues.stripeMinimum || ""}
              onChange={handleChange}
              isInvalid={errors.stripeMinimum}
            />
            {errors.stripeMinimum && (
              <Text color="red.500" fontSize="sm">
                Stripe Minimum is required.
              </Text>
            )}
          </VStack>

          <VStack align="start" width="100%">
            <Text as="b">
              Stripe Target{" "}
              <Text as="span" color="red">
                *
              </Text>
            </Text>
            <Input
              type="number"
              name="stripeTarget"
              value={stripeValues.stripeTarget || ""}
              onChange={handleChange}
              isInvalid={errors.stripeTarget}
            />
            {errors.stripeTarget && (
              <Text color="red.500" fontSize="sm">
                Stripe Target is required.
              </Text>
            )}
          </VStack>
        </VStack>
      </ModalBody>
      <ModalFooter>
        <Button mr={3} onClick={handleOnClose}>
          Cancel
        </Button>
        <Button colorScheme="carrotOrange" onClick={handleSubmit}>
          Launch Carrot Card
        </Button>
      </ModalFooter>
    </>
  )
}
